<template lang="pug">
div.animated.fadeIn
  b-card
    div.row
      div.col-sm-5
        h4.card-title.mb-0
          | CRM
        div.small.text-muted
          | Displaying upcoming appointments
      div.col-sm-7.hidden-sm-down
        b-btn.pull-right(type='button', variant='primary')
          i.icon-cloud-download
          |   Export
    br
    crm-table
</template>

<script>
export default {
  name: 'dashboard',
  data() {
    return {
    }
  },
  mounted: function() {
  },
}
</script>



// WEBPACK FOOTER //
// src/views/CRM.vue?0a93f945